import type { RouteLocationRaw } from 'vue-router'

export type GlobalSearchEntityType =
  | 'driver'
  | 'platform_partner_driver'
  | 'asset'
  | 'platform_partner_asset'
  | 'tracking_device'
  | 'bike'
  | 'client'
  | 'user'
  | 'ticket'
  | 'applicant'

export interface GlobalSearchResult {
  id: string
  type: GlobalSearchEntityType
  title: string
  subtitle?: string
  meta?: string
  route: RouteLocationRaw
}

export interface GlobalSearchGroup {
  type: GlobalSearchEntityType
  label: string
  icon: string
  results: GlobalSearchResult[]
}

export const GLOBAL_SEARCH_ENTITY_LABELS: Record<GlobalSearchEntityType, string> = {
  driver: 'Drivers',
  platform_partner_driver: 'Platform Partner Drivers',
  asset: 'Assets',
  platform_partner_asset: 'Platform Partner Assets',
  tracking_device: 'Tracking Devices',
  bike: 'Bikes',
  client: 'Clients',
  user: 'Users',
  ticket: 'Tickets',
  applicant: 'Applicants',
}

export const GLOBAL_SEARCH_ENTITY_ICONS: Record<GlobalSearchEntityType, string> = {
  driver: 'moped',
  platform_partner_driver: 'link',
  asset: 'directions_car',
  platform_partner_asset: 'link',
  tracking_device: 'gps_fixed',
  bike: 'pedal_bike',
  client: 'business',
  user: 'manage_accounts',
  ticket: 'confirmation_number',
  applicant: 'assignment_ind',
}
